import store from '@/utils/store';
import apiHelper from '@/utils/apiHelpers';

const normalizePath = path => {
	const normalized = String(path || '').trim().replace(/\/+$/, '');
	return normalized || '/';
};

const flattenModuleRoutes = modules => (modules || []).flatMap(module => [
	module.route,
	...(module.sub_modules || []).map(subModule => subModule.route),
]).filter(Boolean).map(normalizePath);

const getModuleRouteForRouteRecord = routeRecordPath => {
	const dynamicSegmentIndex = String(routeRecordPath || '').indexOf('/:');
	return dynamicSegmentIndex === -1
		? normalizePath(routeRecordPath)
		: normalizePath(routeRecordPath.slice(0, dynamicSegmentIndex));
};

export const isRouteInUserModules = (routeRecordPath, modules = store.state.userModules) => {
	const requiredPath = getModuleRouteForRouteRecord(routeRecordPath);
	return flattenModuleRoutes(modules).some(modulePath => modulePath === requiredPath);
};

export const loadUserModules = async router => {
	const userId = Number(store.state.loggedUser?.id);
	const roleId = Number(store.state.loggedUser?.role_id);
	if (!userId || !roleId) return [];

	if (store.state.modulesLoadedForUserId === userId) {
		return store.state.userModules;
	}

	const response = await apiHelper.get(`/modules/role/${roleId}`, router);
	if (!response?.success || !Array.isArray(response.modules)) {
		throw new Error('Unable to load user modules');
	}

	store.commit('setUserModules', { userId, modules: response.modules });
	return response.modules;
};
